import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  CircularProgress,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import { toast, ToastContainer } from "react-toastify";
import { IoMdRadioButtonOn } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import { axiosInstance } from "../../axiosInstance";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";

export const ViewDeliveryIdWiseUnassign = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const deliveryId = params.id;
  const [ordersData, setOrdersData] = useState(null);
  const [riderData, setRiderData] = useState([]);
  async function FetchData() {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/admin/unassigned/delivery-details/${deliveryId}/`,
      );
      if (response.data.status === "success" || response.status === 200) {
        setOrdersData(response.data?.data?.orders);
        setRiderData(response.data?.data?.rider_responses);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to fetch data");
      console.log(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch data",
      );
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchData();
  }, []);
  return (
    <>
      <ToastContainer />
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "#1265c5" }} />
          </Stack>
        </div>
      )}

      <div className="arrowNavigation">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate(`/delivery`)}
        />
        <div>Order in this Delivery</div>
        <div>{""}</div>
      </div>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell align="center" className="table-header">
                  Order ID
                </TableCell>
                <TableCell align="center" className="table-header">
                  Order Type
                </TableCell>
                <TableCell align="center" className="table-header">
                  Pickup Location
                </TableCell>
                <TableCell align="center" className="table-header">
                  Drop Location
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {ordersData ? (
                (() => {
                  const orderItemIds = Array.isArray(ordersData.orderitem_id)
                    ? ordersData.orderitem_id
                    : [ordersData.orderitem_id];
                  const orderIds = Array.isArray(ordersData.order_ids)
                    ? ordersData.order_ids
                    : [ordersData.order_ids];

                  const pickups = Array.isArray(ordersData.pickup)
                    ? ordersData.pickup
                    : [ordersData.pickup];

                  const drops = Array.isArray(ordersData.drop)
                    ? ordersData.drop
                    : [ordersData.drop];

                  const rowCount = Math.max(
                    orderIds.length,
                    orderItemIds.length,
                    pickups.length,
                    drops.length,
                  );
                  // const orderId = ordersData.order_ids?.[0];

                  return Array.from({ length: rowCount }).map((_, index) => (
                    <TableRow key={`${orderItemIds[index] ?? index}-${index}`}>
                      {/* Order ID */}
                      {orderItemIds.length === 1 ? (
                        index === 0 && (
                          <TableCell
                            rowSpan={rowCount}
                            align="center"
                            className="tableCelldata"
                            onClick={() =>
                              navigate(`/view-new-delivery/${orderItemIds[0]}`) // send order_itemsId
                            }
                            style={{ color: "#4184D1", cursor: "pointer" }}
                          >
                            {/* show order_ids  */}
                            {orderIds[0]} 
                          </TableCell>
                        )
                      ) : (
                        <TableCell
                          align="center"
                          className="tableCelldata"
                          onClick={() =>
                            navigate(
                              `/view-new-delivery/${orderItemIds[index]}`,
                            )
                          }
                          style={{ color: "#4184D1", cursor: "pointer" }}
                        >
                          {orderIds[index]}
                        </TableCell>
                      )}

                      {/* Order Type */}
                      {index === 0 && (
                        <TableCell
                          rowSpan={rowCount}
                          align="center"
                          className="tableCelldata"
                        >
                          {ordersData.order_type}
                        </TableCell>
                      )}

                      {/* Pickup */}
                      {pickups.length === 1 ? (
                        index === 0 && (
                          <TableCell
                            rowSpan={rowCount}
                            align="left"
                            className="tableCelldata"
                          >
                            <IoMdRadioButtonOn
                              style={{
                                fontSize: "18px",
                                color: "#34C759",
                                marginRight: "10px",
                              }}
                            />
                            {pickups[0]}
                          </TableCell>
                        )
                      ) : (
                        <TableCell align="left" className="tableCelldata">
                          <IoMdRadioButtonOn
                            style={{
                              fontSize: "18px",
                              color: "#34C759",
                              marginRight: "10px",
                            }}
                          />
                          {pickups[index] ?? ""}
                        </TableCell>
                      )}

                      {/* Drop */}
                      {drops.length === 1 ? (
                        index === 0 && (
                          <TableCell
                            rowSpan={rowCount}
                            align="left"
                            className="tableCelldata"
                          >
                            <FaLocationDot
                              style={{
                                fontSize: "18px",
                                color: "#F52D56",
                                marginRight: "10px",
                              }}
                            />
                            {drops[0]}
                          </TableCell>
                        )
                      ) : (
                        <TableCell align="left" className="tableCelldata">
                          <FaLocationDot
                            style={{
                              fontSize: "18px",
                              color: "#F52D56",
                              marginRight: "10px",
                            }}
                          />
                          {drops[index] ?? ""}
                        </TableCell>
                      )}
                    </TableRow>
                  ));
                })()
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={4}
                    align="center"
                    style={{ padding: "40px 0" }}
                  >
                    No Data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* ryder response table  */}
      <div className="admin-top-container" style={{ marginTop: "40px" }}>
        <div className="admin-listText">Ryder Responses</div>
      </div>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ maxHeight: 500 }} className="Table-container">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="center" className="table-header">
                  RYDER ID
                </TableCell>

                <TableCell align="center" className="table-header">
                  RYDER NAME
                </TableCell>

                <TableCell align="center" className="table-header">
                  VEHICLE
                </TableCell>

                <TableCell align="center" className="table-header">
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {riderData.length > 0 ? (
                riderData.map((row, index) => (
                  <TableRow
                    key={row.rider_id}
                    //   hover
                    className="table-row"
                    sx={{
                      backgroundColor: index % 2 === 1 ? "#EEF5FC" : "#fff",
                    }}
                  >
                    <TableCell align="center" className="tableCelldata">
                      {row.rider_id}
                    </TableCell>

                    <TableCell align="center" className="tableCelldata">
                      {row.rider_name}
                    </TableCell>

                    <TableCell align="center" className="tableCelldata">
                      {row.vehicle_type}
                    </TableCell>

                    <TableCell
                      align="center"
                      className="tableCelldata action-cell"
                    >
                      <span
                        className={
                          row.response === "rejected"
                            ? "text-danger"
                            : "text-success"
                        }
                      >
                        {row.response}
                      </span>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={4}
                    align="center"
                    style={{ padding: "40px 0" }}
                  >
                    No Data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
};
